export default {
  removeUserFilters: async ({ commit }, users) => {
    commit('removeUserFilters', users)
  },
  addUserFilters: async ({ commit }, users) => {
    commit('addUserFilters', users)
  },
  addBudgetsFilters: async ({ commit }, budgets) => {
    commit('addBudgetsFilters', budgets)
  },
  removeBudgetsFilters: async ({ commit }, budgets) => {
    commit('removeBudgetsFilters', budgets)
  },
  clearStore: ({ commit }) => {
    commit('clearStoreData')
  }
}
